module.exports = __webpack_public_path__ + "static/media/startstop1.dfce9b7f.wav";